class BwsProductGroupNavigation extends HTMLElement {
  #controller;
  #preview;
  #previewTitle;
  #previewPrice;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#preview = this.querySelector('[data-preview]');
    this.#previewTitle = this.#preview?.querySelector('[data-preview-title]');
    this.#previewPrice = this.#preview?.querySelector('[data-preview-price]');

    if (!this.#preview || !this.#previewTitle || !this.#previewPrice) return;

    document.body.append(this.#preview);

    const { signal } = this.#controller;
    this.addEventListener('pointermove', this.#handlePointerMove, { signal });
    this.addEventListener('pointerleave', this.#hidePreview, { signal });
    this.addEventListener('focusin', this.#handleFocusIn, { signal });
    this.addEventListener('focusout', this.#handleFocusOut, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#hidePreview();

    if (this.#preview && !this.contains(this.#preview)) {
      this.append(this.#preview);
    }
  }

  #handlePointerMove = (event) => {
    if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;

    const link = event.target instanceof Element ? event.target.closest('[data-preview-title]') : null;
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) {
      this.#hidePreview();
      return;
    }

    this.#showPreview(link, event.clientX, event.clientY);
  };

  #handleFocusIn = (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-preview-title]') : null;
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;

    const bounds = link.getBoundingClientRect();
    this.#showPreview(link, bounds.right, bounds.top + bounds.height / 2);
  };

  #handleFocusOut = (event) => {
    if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
    this.#hidePreview();
  };

  #showPreview(link, requestedX, requestedY) {
    this.#previewTitle.textContent = link.dataset.previewTitle ?? '';
    this.#previewPrice.textContent = link.dataset.previewPrice ?? '';
    this.#preview.dataset.visible = 'true';

    const previewWidth = this.#preview.offsetWidth;
    const previewHeight = this.#preview.offsetHeight;
    const edgeGap = 16;
    const cursorGap = 50;
    const requestedPreviewX = requestedX + cursorGap;
    const maximumX = Math.max(edgeGap, window.innerWidth - previewWidth - edgeGap);
    const maximumY = Math.max(previewHeight / 2 + edgeGap, window.innerHeight - previewHeight / 2 - edgeGap);
    const x = Math.min(Math.max(requestedPreviewX, edgeGap), maximumX);
    const y = Math.min(Math.max(requestedY, previewHeight / 2 + edgeGap), maximumY);

    this.#preview.style.setProperty('--bws-preview-x', `${x}px`);
    this.#preview.style.setProperty('--bws-preview-y', `${y}px`);
  }

  #hidePreview = () => {
    if (this.#preview) this.#preview.dataset.visible = 'false';
  };
}

if (!customElements.get('bws-product-group-navigation')) {
  customElements.define('bws-product-group-navigation', BwsProductGroupNavigation);
}
